export default __webpack_public_path__ + "static/media/pdf-icon.c489bddd.svg";